import DatePicker from '@/vuetify_custom/v-date-picker'
import { defaultFun } from '../utils'
import { DATE_PICKER } from '../type_name'
import commonMixins from './commonMixins'
export default {
    name: DATE_PICKER,
    mixins: [ commonMixins ],
    render(h) {
        const {
                         // eslint-disable-next-line 
                         slots,scopedSlots,
             key,
             input = defaultFun,
             change = defaultFun,
             ...params 
            } = this.field
            params.locale = params.locale || "zh-cn"
            if (params.attach === undefined) {
                params.attach = true
            }
        return h(DatePicker, {
            slots: this.slots,
            scopedSlots:  this.separateSlot && this.separateSlot() || {},
            props: {
                ...params,
                value: this.my_value[key]
            },
            on: {
                input:(data) => {
                    this.my_value[key] = data
                    input(data)
                },
                change: (data) => {
                    change(data)
                }
            }
        })
    }
}